/**
 * Every query key in the app, in one file.
 *
 * The realtime bridge writes into these caches by key from outside React, so a
 * key spelled slightly differently in a component than in the bridge produces
 * the worst bug this app can have: a board that looks live and is not. One
 * source, imported by both.
 */

export const keys = {
  me: ['me'] as const,
  board: ['board'] as const,
  parked: ['parked'] as const,
  resolvedToday: ['resolved-today'] as const,
  setting: (key: string) => ['setting', key] as const,
  conversation: (id: string) => ['conversation', id] as const,
  /** The infinite list of messages for one thread. */
  messages: (id: string) => ['conversation', id, 'messages'] as const,
  /** Prefix used to invalidate every open thread at once. */
  conversationRoot: ['conversation'] as const,
};
